import type { Observable } from 'rxjs';
import { inject, Injectable, InjectionToken } from '@angular/core';

export const MapDataServices = new InjectionToken<Array<MapDataService<unknown, unknown>>>('map-data-services');

/**
 * helper function to inject a data service with a specific type
 */
export function injectMapDataServices<I, F>(): Array<MapDataService<I, F>> {
    return inject(MapDataServices) as Array<MapDataService<I, F>>;
}

@Injectable()
export abstract class MapDataService<Item, Filter> {
    public abstract getData$(filter: Filter): Observable<Array<Item>>;
}
